import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20 lg:h-24">
          <div className="flex items-center">
            <div className="flex items-center space-x-3">
              <div className={`w-12 h-12 lg:w-14 lg:h-14 rounded-lg flex items-center justify-center ${isScrolled ? 'bg-gradient-to-br from-amber-400 to-yellow-600' : 'bg-gradient-to-br from-amber-300 to-yellow-500'}`}>
                <i className="ri-car-line text-2xl lg:text-3xl text-white"></i>
              </div>
              <div className="flex flex-col">
                <span className={`text-xl lg:text-2xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                  REGAL
                </span>
                <span className={`text-xs lg:text-sm font-semibold tracking-wider ${isScrolled ? 'text-amber-600' : 'text-amber-300'}`}>
                  SPRINTER
                </span>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('fleet')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Fleet
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              About Us
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Contact
            </button>
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:7139996733" className={`flex items-center space-x-2 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              <i className="ri-phone-line text-lg"></i>
              <span>713-999-6733</span>
            </a>
            <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
              Book Now
            </button>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden cursor-pointer"
          >
            <i className={`text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-gray-900 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-900 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('fleet')} className="block w-full text-left text-gray-900 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap">
              Fleet
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-900 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap">
              About Us
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-900 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-900 hover:text-teal-600 font-medium cursor-pointer whitespace-nowrap">
              Contact
            </button>
            <a href="tel:7139996733" className="flex items-center space-x-2 text-gray-900 hover:text-teal-600 font-semibold cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line"></i>
              <span>713-999-6733</span>
            </a>
            <button onClick={() => scrollToSection('contact')} className="w-full bg-teal-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
              Book Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
